export const enClientPortalValuationPlausibilityPage = {
    panels: {
        pdf: {
            title: 'Draft PDF',
        },
        annotations: {
            title: 'Comments',
        },
    },
    textBubble: {
        actions: {
            edit: 'Edit',
            deleteAnnotation: 'Delete comment',
            deleteThread: 'Delete entire conversation',
            delete: 'Delete',
            cancel: 'Cancel',
            reply: 'Reply',
            close: 'Close',
        },
        unknownUser: 'Unknown',
        createdInDraft: 'Created in draft {{draftVersion}}',
        editAnnotationPlaceholder: 'Write a comment',
        editReplyPlaceholder: 'Write a reply',
        createAnnotationPlaceholder: 'Write a comment...',
        createReplyPlaceholder: 'Write a reply...',
        deletedAnnotation: 'This comment was deleted.',
        edited: 'edited',
        deleteModalTitle: 'Delete comment',
        deleteConfirmation: 'Are you sure you want to delete this comment? This action cannot be undone.',
        deleteConfirmationWithReplies: 'Are you sure you want to delete this comment and all replies? This action cannot be undone.',
        notificationTooltip: 'The customer will be informed about new comments in the daily report.',
        immediatelyVisible: 'Comment immediately visible to the appraiser',
    },
    userLink: {
        me: 'Me',
        external: 'External',
        unknown: 'Not set',
        contact: 'Contact',
        editOwnContactTooltip: 'Edit own contact details',
        emailCopied: 'Email address copied',
        phoneCopied: 'Phone number copied',
        addressCopied: 'Address copied',
        note: 'Note',
        externalEmailInfo: 'This contact collaborates by email.',
    },
}
